import WarningIcon from 'components/icons/WarningIcon';
import React from 'react';

const CSS = require('./WarningMessage.module.scss');

function WarningMessage({ text }) {
  return (
    <div className={CSS.WarningMessage}>
      <WarningIcon width={20} height={20} className={CSS.Icon} />
      <span className={CSS.Text}>{text}</span>
    </div>
  );
}

export default WarningMessage;
